import * as React from 'react';
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  FunctionField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from 'react-admin';
import Filter from './filter';
import Pagination from '../pagination';
import { ImageField } from '../fields';
import BulkActions from './bulk-actions/';

export default (props) => {
  return(
  <List
    filters={<Filter permissions={props.permissions} />}
    sort={{ field: 'id', order: 'DESC' }}
    pagination={<Pagination />}
    perPage={100}
    {...props}
    bulkActionButtons={<BulkActions />}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="provider_id" reference="users" link={false}>
        <FunctionField render={(record) => `${record.first_name} ${record.last_name}`} />
      </ReferenceField>
      <ImageField source="preview" width="60" />
      <TextField source="first_name" />
      <TextField source="last_name" />
      <TextField source="country" />
      <ReferenceArrayField source="artTypes" label="Art Types" reference="art-types">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
        <TextField source="price_tier" />
      )}
      {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
        <TextField source="license_type" />
      )}
      <TextField label="Last Modified" source="updatedAt" />
    </Datagrid>
  </List>
  )
};
